module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-finalize/payroll-finalize.component.css
// module id = ./src/app/hrms/payroll/payroll-finalize/payroll-finalize.component.css
// module chunks = main